import styles from './Heading.module.scss';

export interface HeadingProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > {
  level?: 1 | 2 | 3 | 4;
  compact?: boolean;
  noPadding?: boolean;
  align?: 'left' | 'center' | 'right';
}

export const Heading = ({
  level = 1,
  compact = false,
  noPadding = false,
  align = 'left',
  ...props
}: HeadingProps) => {
  return (
    <header
      {...props}
      className={styles.heading}
      data-test-id="heading-container"
      data-level={level}
      data-compact={compact}
      data-no-padding={noPadding}
      data-align={align}
    />
  );
};
